import { useApiGetPenilaianCountPsTabGuru } from 'api/kinerja/kepala-sekolah/guru/pengawas-sekolah/penilaian'
import { useApiGetPenilaianCountPs } from 'api/kinerja/kepala-sekolah/pengawas-sekolah/penilaian'

const usePenetapanCountPs = ({ enabled = false }: { enabled: boolean }) => {
  const {
    data: { data: counterKs } = {},
    isLoading: isLodingCountKs,
    isFetched: isFetchedKs,
  } = useApiGetPenilaianCountPs({
    enabled,
  })

  const {
    data: { data: counterGuru } = {},
    isLoading: isLodingCountGuru,
    isFetched: isFetchedGuru,
  } = useApiGetPenilaianCountPsTabGuru({
    enabled,
  })

  return {
    isLoading: isLodingCountKs || isLodingCountGuru,
    isSuccess: isFetchedKs || isFetchedGuru,
    data: {
      belumDikirim:
        parseInt(`${counterKs?.belumDikirim || 0}`, 10) +
        parseInt(`${counterGuru?.belumDikirim || 0}`, 10),
      sudahDikirim:
        parseInt(`${counterKs?.sudahDikirim || 0}`, 10) +
        parseInt(`${counterGuru?.sudahDikirim || 0}`, 10),
      all:
        parseInt(`${counterKs?.all || 0}`, 10) +
        parseInt(`${counterGuru?.all || 0}`, 10),
    },
    detail: {
      ks: counterKs ?? { belumDikirim: 0, sudahDikirim: 0, all: 0 },
      guru: counterGuru ?? { belumDikirim: 0, sudahDikirim: 0, all: 0 },
    },
  }
}

export default usePenetapanCountPs
